import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import SvcImage from 'shared/app/components/svc-image';

import sharedMessages from '../shared-messages';

const ManageCardImageLink = ({
  cardId,
  cardImageUrl,
  cardNickname,
  imageClassName,
}) => {
  const { formatMessage } = useIntl();

  return (
    <Link
      className="block"
      data-e2e="manageCardImageLink"
      to={`/account/cards/${cardId}`}
    >
      <SvcImage
        altText={formatMessage(sharedMessages.cardImageAltText, {
          cardNickname,
        })}
        imageClassName={imageClassName}
        src={cardImageUrl}
      />
    </Link>
  );
};

ManageCardImageLink.propTypes = {
  cardId: PropTypes.string.isRequired,
  cardImageUrl: PropTypes.string.isRequired,
  cardNickname: PropTypes.string.isRequired,
};

export default ManageCardImageLink;
